import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { ChartCard } from "../../../components/charts/ChartCard";
import { CHART_COLORS, CHART_TEXT, chartSx } from "../../../components/charts/chartTheme";

type FacultyAttendanceData = {
  category: string;
  attendance: number;
};

type FacultyAttendanceChartProps = {
  data: FacultyAttendanceData[];
};

// One measure across categories, so one colour; the category is already named on the axis.
// Horizontal bars keep long category names ("Ground / Maintenance") readable.
export const FacultyAttendanceByCategoryChart = ({
  data,
}: FacultyAttendanceChartProps) => {
  return (
    <Box sx={{ width: "100%", height: "100%", minWidth: 0 }}>
      <ChartCard title="Staff Attendance by Category">
        {data.length === 0 &&
          <Typography sx={{ fontSize: { xs: 14, md: 15 }, fontWeight: 600, color: CHART_TEXT.muted, py: 2 }}>
            Not submitted.
          </Typography>
        }
        {data.length > 0 &&
          <BarChart
            height={Math.max(160, data.length * 48 + 30)}
            layout="horizontal"
            hideLegend
            dataset={data}
            yAxis={[{ scaleType: "band", dataKey: "category", width: 150, disableLine: true, disableTicks: true, categoryGapRatio: 0.35 }]}
            xAxis={[{ disableLine: true, disableTicks: true, tickMinStep: 1 }]}
            series={[{ dataKey: "attendance", label: "Attendance", color: CHART_COLORS.series1 }]}
            barLabel="value"
            borderRadius={4}
            grid={{ vertical: true }}
            margin={{ top: 0, right: 24, bottom: 0, left: 0 }}
            sx={{ ...chartSx, "& .MuiBarLabel-root": { fill: "#fff", fontSize: 11, fontWeight: 600 } }}
          />
        }
      </ChartCard>
    </Box>
  );
};
